/* apps/viewer/src/app/help-module/disclaimer/disclaimer.component.scss */
.ori-elevation-z0 {
  box-shadow: var(--mat-app-elevation-shadow-level-0);
}
.ori-elevation-z1 {
  box-shadow: var(--mat-app-elevation-shadow-level-1);
}
.ori-elevation-z2 {
  box-shadow: var(--mat-app-elevation-shadow-level-2);
}
.ori-elevation-z3 {
  box-shadow: var(--mat-app-elevation-shadow-level-3);
}
.ori-elevation-z4 {
  box-shadow: var(--mat-app-elevation-shadow-level-4);
}
.ori-elevation-z5 {
  box-shadow: var(--mat-app-elevation-shadow-level-5);
}
.ori-elevation-z6 {
  box-shadow: var(--mat-app-elevation-shadow-level-6);
}
.ori-elevation-z7 {
  box-shadow: var(--mat-app-elevation-shadow-level-7);
}
.ori-elevation-z8 {
  box-shadow: var(--mat-app-elevation-shadow-level-8);
}
.ori-elevation-z9 {
  box-shadow: var(--mat-app-elevation-shadow-level-9);
}
.ori-elevation-z10 {
  box-shadow: var(--mat-app-elevation-shadow-level-10);
}
.ori-elevation-z11 {
  box-shadow: var(--mat-app-elevation-shadow-level-11);
}
.ori-elevation-z12 {
  box-shadow: var(--mat-app-elevation-shadow-level-12);
}
.ori-elevation-z13 {
  box-shadow: var(--mat-app-elevation-shadow-level-13);
}
.ori-elevation-z14 {
  box-shadow: var(--mat-app-elevation-shadow-level-14);
}
.ori-elevation-z15 {
  box-shadow: var(--mat-app-elevation-shadow-level-15);
}
.ori-elevation-z16 {
  box-shadow: var(--mat-app-elevation-shadow-level-16);
}
.ori-elevation-z17 {
  box-shadow: var(--mat-app-elevation-shadow-level-17);
}
.ori-elevation-z18 {
  box-shadow: var(--mat-app-elevation-shadow-level-18);
}
.ori-elevation-z19 {
  box-shadow: var(--mat-app-elevation-shadow-level-19);
}
.ori-elevation-z20 {
  box-shadow: var(--mat-app-elevation-shadow-level-20);
}
.ori-elevation-z21 {
  box-shadow: var(--mat-app-elevation-shadow-level-21);
}
.ori-elevation-z22 {
  box-shadow: var(--mat-app-elevation-shadow-level-22);
}
.ori-elevation-z23 {
  box-shadow: var(--mat-app-elevation-shadow-level-23);
}
.ori-elevation-z24 {
  box-shadow: var(--mat-app-elevation-shadow-level-24);
}
::ng-deep .disclaimer-dialog-container {
  --mat-dialog-container-max-width: 100dvw;
  --mat-dialog-container-min-width: 100dvw;
  max-height: 100dvh;
  min-height: 100dvh;
}
::ng-deep .disclaimer-dialog-container ::ng-deep .mat-mdc-dialog-container {
  overflow: hidden;
  padding: 0;
}
::ng-deep .disclaimer-dialog-container ::ng-deep .mat-mdc-dialog-container .header {
  box-sizing: border-box;
  color: #fafafa;
  display: flex;
  height: 60px;
  justify-content: space-between;
  padding-right: 0;
  position: sticky;
  top: 0;
  z-index: 1000;
}
::ng-deep .disclaimer-dialog-container ::ng-deep .mat-mdc-dialog-container img {
  margin-right: 10px;
  max-width: 100px;
  vertical-align: middle;
}
::ng-deep .disclaimer-dialog-container ::ng-deep .mat-mdc-dialog-container .mat-icon {
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 60px;
  justify-content: center;
  transition: all ease 0.3s;
  width: 60px;
}
::ng-deep .disclaimer-dialog-container ::ng-deep .mat-mdc-dialog-container .mat-icon ::ng-deep svg {
  fill: #fafafa;
  height: 30px;
  transition: all ease 0.3s;
  width: 30px;
}
::ng-deep .disclaimer-dialog-container ::ng-deep .mat-mdc-dialog-container .mat-icon:hover,
::ng-deep .disclaimer-dialog-container ::ng-deep .mat-mdc-dialog-container .mat-icon:focus {
  transition: all ease 0.3s;
}
::ng-deep .disclaimer-dialog-container ::ng-deep .mat-mdc-dialog-container .mat-icon:hover ::ng-deep svg,
::ng-deep .disclaimer-dialog-container ::ng-deep .mat-mdc-dialog-container .mat-icon:focus ::ng-deep svg {
  fill: #fafafa;
  transition: all ease 0.3s;
}
::ng-deep .disclaimer-dialog-container ::ng-deep .mat-mdc-dialog-container .content-container {
  height: calc(100dvh - 140px);
  max-height: calc(100dvh - 140px);
  padding: 10px 24px 24px;
}
::ng-deep .disclaimer-dialog-container ::ng-deep .mat-mdc-dialog-container .content-container-edit {
  height: calc(100dvh - 60px);
  max-height: calc(100dvh - 60px);
}
::ng-deep .disclaimer-dialog-container ::ng-deep .mat-mdc-dialog-container .content-container .content {
  margin: auto;
  max-width: 1024px;
}
::ng-deep .disclaimer-dialog-container ::ng-deep .mat-mdc-dialog-container .content-container table {
  border-collapse: collapse;
  display: block;
  overflow-x: auto;
  white-space: nowrap;
  width: 100%;
}
::ng-deep .disclaimer-dialog-container ::ng-deep .mat-mdc-dialog-container .content-container table td {
  border: 1px solid;
  padding: 5px !important;
}
::ng-deep .disclaimer-dialog-container ::ng-deep .mat-mdc-dialog-container .content-container table td p {
  margin-block: 0 !important;
}
::ng-deep .disclaimer-dialog-container ::ng-deep .mat-mdc-dialog-container .actions {
  align-items: stretch;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding: 20px 0;
}
::ng-deep .disclaimer-dialog-container ::ng-deep .mat-mdc-dialog-container .actions form {
  margin: auto;
}
::ng-deep .disclaimer-dialog-container ::ng-deep .mat-mdc-dialog-container .actions form .mat-radio-group {
  display: flex;
  flex-direction: column;
}
::ng-deep .disclaimer-dialog-container ::ng-deep .mat-mdc-dialog-container .actions button {
  margin: auto;
}
/*# sourceMappingURL=disclaimer.component.css.map */
